





import { Vue, Component } from 'vue-property-decorator'

import NotificationsList from './List.vue'

@Component({
  components: {
    NotificationsList
  }
})
export default class NotificationsPage extends Vue {

}
